module.exports = __webpack_public_path__ + "img/i_file.5321a88c.svg";